import "./results-block.scss";